<template>
  <div>
    <Title :pages="[{ icon: 'scale-balanced', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object></v-combobox>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="desde_menu"
                    v-model="desde_menu"
                    :close-on-content-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.desde_menu.save(desde_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="hasta_menu"
                    v-model="hasta_menu"
                    :close-on-content-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_menu.save(hasta_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-combobox v-model="grupo_selected" autocomplete="off" item-text="name" item-value="id" :items="grupos" label="Grupo" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col-md-2 pt-0">
                  <v-combobox v-model="cost_center_selected" autocomplete="off" item-text="name" item-value="id" :items="cost_centers" label="Centro de Costo" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" :disabled="!emitter_selected" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Sumas y Saldos -->
      <v-card>
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
        </v-card-title>

        <v-progress-linear v-if="loading" indeterminate color="info"></v-progress-linear>

        <div class="pa-2" style="overflow-x: auto">
          <div v-if="loading" class="pa-6 text-center grey--text">Cargando...</div>

          <div v-else-if="data">
            <v-alert v-if="!data.totales.balanceado" type="error" dense text class="mx-2">
              El total del Debe no coincide con el del Haber. Hay asientos descuadrados: revisá el Libro Diario.
            </v-alert>

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th class="text-left">Cuenta</th>
                    <th class="text-left">Grupo</th>
                    <th class="text-right">Debe</th>
                    <th class="text-right">Haber</th>
                    <th class="text-right">Saldo Deudor</th>
                    <th class="text-right">Saldo Acreedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in data.cuentas" :key="'c-' + c.account_id">
                    <td>{{ c.code }}</td>
                    <td>{{ c.name }}</td>
                    <td>{{ c.grupo_name }}</td>
                    <td class="text-right">{{ formatUtils.formatPrice(c.debe) }}</td>
                    <td class="text-right">{{ formatUtils.formatPrice(c.haber) }}</td>
                    <td class="text-right">{{ c.saldo_deudor ? formatUtils.formatPrice(c.saldo_deudor) : "" }}</td>
                    <td class="text-right">{{ c.saldo_acreedor ? formatUtils.formatPrice(c.saldo_acreedor) : "" }}</td>
                  </tr>

                  <tr v-if="data.cuentas.length === 0">
                    <td colspan="7" class="text-center grey--text py-4">No hay movimientos contables en el período.</td>
                  </tr>

                  <tr class="blue lighten-5">
                    <td colspan="3" class="font-weight-bold">TOTALES</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.debe) }}</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.haber) }}</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.saldo_deudor) }}</td>
                    <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.saldo_acreedor) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div v-else class="pa-6 text-center grey--text">Elegí emisor y período, y presioná Buscar.</div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Title from "@/components/Title.vue";

export default {
  components: { Title },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      page_title: "Sumas y Saldos",
      formatUtils: formatUtils,
      data: null,
      desde_menu: false,
      hasta_menu: false,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      emitters: [],
      emitter_selected: null,
      cost_centers: [],
      cost_center_selected: null,
      grupo_selected: null,
      grupos: [
        { id: 1, name: "Activo" },
        { id: 2, name: "Pasivo" },
        { id: 3, name: "Patrimonio Neto" },
        { id: 4, name: "Ingresos" },
        { id: 5, name: "Egresos" },
      ],
    };
  },
  mounted() {
    this.loadCombos();
  },
  methods: {
    loadCombos() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.filter();
        }
      });
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.cost_centers = response.result;
      });
    },
    getFilterParams() {
      return {
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        from: this.desde_selected,
        to: this.hasta_selected,
        grupo: this.grupo_selected != null ? this.grupo_selected.id : null,
        cost_center: this.cost_center_selected != null ? this.cost_center_selected.id : null,
      };
    },
    filter() {
      if (this.emitter_selected == null) return;
      this.loading = true;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_SUMAS_Y_SALDOS)
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_SUMAS_Y_SALDOS, param, "Sumas-y-Saldos.xlsx");
    },
  },
};
</script>
